import { NzPlacementType } from 'ng-zorro-antd/dropdown';

import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';

import { AdminFeatureFlagService } from '@app/services/feature-flags/admin';
import { NzTriggerType } from '@lib/utils';

export interface IKebabMenuOption {
  isOptionDivider?: boolean;
  label: string;
  labelType?: KEBAB_MENU_LABEL_TYPES;
  key: string;
  isDisabled?: boolean;
  isHidden?: boolean;
}

export type PlacementType = NzPlacementType;

export enum KEBAB_MENU_LABEL_TYPES {
  DANGER = 'danger',
}

@Component({
  selector: 'kebab-menu',
  templateUrl: './kebab-menu.component.html',
  styleUrls: ['./kebab-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class KebabMenuComponent {
  @Input() public menuOptions: IKebabMenuOption[] = [];
  @Input() public menuPlacement: PlacementType = 'bottomLeft';
  @Input() public menuTrigger: NzTriggerType = 'click';
  @Input() public buttonIcon: string = '/ellipsis.svg';
  @Input() public hideOnClick: boolean = true;
  @Input() public isVisible: boolean = false;
  @Input() public isDisabled: boolean = false;
  @Input() public height: number = 28;
  @Input() public width: number = 36;
  public labelType: typeof KEBAB_MENU_LABEL_TYPES = KEBAB_MENU_LABEL_TYPES;

  public readonly experimentalImplementation: boolean;

  @Output() public readonly toggleDropdown = new EventEmitter<boolean>();
  @Output() public readonly onOptionSelection = new EventEmitter<IKebabMenuOption>();

  private isDropdownOpen: boolean;

  constructor(
    private adminFeatureFlagService: AdminFeatureFlagService,
  ) {
    this.experimentalImplementation = this.adminFeatureFlagService.isGroupFilterInNewHeaderEnabled();
  }

  public onToggleDropdown(): void {
    this.isDropdownOpen = !this.isDropdownOpen;
    this.toggleDropdown.emit(this.isDropdownOpen);
  }

  public onOptionSelect(selectedValue: IKebabMenuOption): void {
    if (selectedValue.isDisabled) return;
    this.onOptionSelection.emit(selectedValue);
  }
}
